<template>
<div class="page ">
  <p class="preheader">
    Overall
  </p>
  <p class="dustin-title ">
    Comparisons
  </p>
  <p class="preheader">Methodology</p>
  <p class="description">
    This shows the comparison of the overall (weighted aggregation) impact of metrics among portfolios. The categories shown are based on the impact preferences you set. 
  </p>
  
  <section class="section">
    <h1 v-if="impact_report.report">
      {{impact_report.report.metrics[0].name}}
      </h1>
  </section>
  
</div> <!-- page-->
</template>

<script>
  import { apiFetch } from '../../../api/api';

  export default {
    data () {
      return {
        impact_report: {}
      }
    },
    created: function() {
      let url = 'http://127.0.0.1:8000/api/v1/portfolios/Jnw/report/impact/'
      apiFetch(url).then(response => response.json()).then(data => this.impact_report = data)
    },
    methods: {
      randomize: function() {
        this.interestingNumber = Math.random() * Math.random();
      }
    },
    components: {}
  }
</script>

<style lang="css" scoped>
</style>
